import { createContext } from 'react';

export const IsActiveDocContext = createContext<boolean | undefined>(undefined);
